
import CryptoJS from 'crypto-js'

export default {
  // 随机生成指定数量的16进制key
  generatekey() {
    const library = '49a1b1409a744f4f874d095267237874'
    const key = library.slice(5, 21)
    // for (var i = 0; i < num; i++) {
    //   const randomPoz = Math.floor(Math.random() * library.length)
    //   key += library.substring(randomPoz, randomPoz + 1)
    // }
    return key
  },

  // 加密
  encrypt(word, keyStr) {
    keyStr = keyStr || 'abcdsxyzhkj12345' // 判断是否存在ksy，不存在就用定义好的key
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    var srcs = CryptoJS.enc.Utf8.parse(word)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  },
  // 解密
  decrypt(word, keyStr) {
    if(word!==null && word!==''){
      keyStr = keyStr || 'abcdsxyzhkj12345'
      var key = CryptoJS.enc.Utf8.parse(keyStr)
      var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    }else{
      return ''
    }
    
  },
  getData() {
    const filePath = '@/assets/img/market_id.txt'
    let xhr = null
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest()
    } else {
      // eslint-disable-next-line
      xhr = new ActiveXObject('Microsoft.XMLHTTP')
    }
    const okStatus = document.location.protocol === 'file' ? 0 : 200
    xhr.open('GET', filePath, false)
    xhr.overrideMimeType('text/html;charset=utf-8')
    xhr.send(null)
    return xhr.status === okStatus ? xhr.responseText : null
  }

}
